import { Box } from '@factorialco/deprecated-design-system'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'

interface Props {
  onChange: (selection: EmployeeSelectorV2MultiSelectState) => void
}

export const BankAccountMembershipSelector = ({ onChange }: Props) => {
  return (
    <Box style={{ width: '500px' }} flexNoShrink flexDirection="column" gap="s8">
      <EmployeeSelectorV2 multiple onChange={onChange} />
    </Box>
  )
}
